import {
  faCalendar,
  faCaretDown,
  faChevronLeft,
  faChevronRight,
  faExclamationCircle,
  faMapMarkerAlt,
  faTimes,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'react-helmet';
import { library } from '@fortawesome/fontawesome-svg-core';
import { Provider } from 'react-redux';
import React, { Component } from 'react';

import '../src/styles/globalStyles';
import Routes from './Routes';
import { setGmapsLoaded } from './redux/actions/google';
import store from './redux/store/store';

library.add(
  faCalendar,
  faCaretDown,
  faChevronLeft,
  faChevronRight,
  faExclamationCircle,
  faMapMarkerAlt,
  faTimes,
  faTrashAlt,
);

class App extends Component {
  componentDidMount() {
    this.initPlacesAPI();
    App.initDoorbell();
  }

  render() {
    return (
      <div>
        {App.helmet}
        <Provider store={store}>
          <Routes />
        </Provider>
      </div>
    );
  }

  static get helmet() {
    return (
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700"
          rel="stylesheet"
        />
      </Helmet>
    );
  }

  initPlacesAPI() {
    window.initMap = this.initMap;
    const gmapScriptEl = document.createElement(`script`);
    gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDJ0-C6_GBV2-BdHAYaKEQo5cIUP_bVMPk&libraries=places&callback=initMap`;
    gmapScriptEl.async = true;
    document.querySelector(`body`).insertAdjacentElement(`beforeend`, gmapScriptEl);
  }

  initMap = () => {
    store.dispatch(setGmapsLoaded());
  };

  static initDoorbell() {
    const scriptEl = document.createElement(`script`);
    scriptEl.innerHTML = `
      window.doorbellOptions = {
        id: '9387',
        appKey: 'yjzLyUrNCMOeOJgcbXWsOz3JncFt6e1cYRlN7BN31b3AImgyQJ0TpuG4gKHknzZk'
      };
      (function(w, d, t) {
        var hasLoaded = false;
        function l() { if (hasLoaded) { return; } hasLoaded = true; window.doorbellOptions.windowLoaded = true; var g = d.createElement(t);g.id = 'doorbellScript';g.type = 'text/javascript';g.async = true;g.src = 'https://embed.doorbell.io/button/'+window.doorbellOptions['id']+'?t='+(new Date().getTime());(d.getElementsByTagName('head')[0]||d.getElementsByTagName('body')[0]).appendChild(g); }
        if (w.attachEvent) { w.attachEvent('onload', l); } else if (w.addEventListener) { w.addEventListener('load', l, false); } else { l(); }
        if (d.readyState == 'complete') { l(); }
      }(window, document, 'script'));
    `;
    scriptEl.async = true;
    document.querySelector(`body`).insertAdjacentElement(`beforeend`, scriptEl);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js